<template>
  <div>
    <!-------------- 入库 -------------->
    <warehousing-delivery
      v-show="type === '入库'"
      :warehousing="warehousing"
      :deliverState="!deliverState"
      :sendType="type"
    ></warehousing-delivery>
    <!-------------- 直发 -------------->

    <direct-delivery
      v-show="type === '直发'"
      :deliverState="!deliverState"
      :sendType="type"
      :warehousing="warehousing"
    ></direct-delivery>
    <!-------------- 二次确认 -------------->
    <open-or-close-dialog
      ref="openOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close-dialog>
  </div>
</template>
<script>
import { queryAllByPcbId } from '@/api/purchase/purchasePlanList' // 根据采购合同id查询正常产品清单（分页)
import directDelivery from './directDelivery' // 直发
import warehousingDelivery from './warehousingDelivery' // 入库
import openOrClose from '@/components/OpenOrClose/index' // 二次确认
export default {
  components: {
    'direct-delivery': directDelivery,
    'warehousing-delivery': warehousingDelivery,
    'open-or-close-dialog': openOrClose
  },
  data () {
    return {
      warehousing: [], // 发货数据
      title: '',
      content: '',
      type: '',
      deliverState: ''
    }
  },
  methods: {
    onInitial (val) {
      this.type = val
    },
    getIsHaveRemind () {
      if (this.type === '入库') {
        this.queryAllByPcbId()
      } else {
        this.queryAllByPcbId()
      }
    },
    // 发货管理退货申请提醒确认
    onUpdataState () {},
    queryAllByPcbId () {
      // 入库
      queryAllByPcbId(this.$route.query.pcbId)
        .then((res) => {
          if (res.data.code === 200) {
            this.type = res.data.obj.purchaseContractBasesVo.sendType
            this.warehousing =
              res.data.obj.purchaseContractBaseStorageWarehousingVoList
            this.deliverState = res.data.obj.deliverState
            if (!res.data.obj.isBack) {
              this.title = '退货申请提醒'
              this.content =
                '当前合同产品中存在处理中的售后退货申请！请谨慎处理！'
              this.$refs.openOrCloseRefs.onInitial()
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}
</script>
